module.exports = __webpack_public_path__ + "img/btn_power3_n.ad2ccb4c.png";